export type CompoLibraryItem = { label: string; to: string };

export type CompoLibraryCategory = {
    title: string;
    icon: string;
    color: string;
    glow?: string;
    items: CompoLibraryItem[];
};

export const compoLibraryCategories: readonly CompoLibraryCategory[] = [
    {
        title: "Layout",
        icon: "layout",
        color: "navy",
        glow: "lg-navy",
        items: [
            { label: "Structure", to: "/docs/layout" },
            { label: "Container", to: "/docs/layout/container" },
            { label: "Grid", to: "/docs/layout/grid" },
            { label: "Stack", to: "/docs/layout/stack" },
        ],
    },
    {
        title: "Forms",
        icon: "form",
        color: "purple",
        items: [
            { label: "Overview", to: "/docs/forms" },
            { label: "Form control", to: "/docs/forms/form-control" },
            { label: "Select", to: "/docs/forms/select" },
            { label: "Checkbox & radios", to: "/docs/forms/checks-radios" },
            { label: "Range", to: "/docs/forms/range" },
            { label: "Input group", to: "/docs/forms/input-group" },
            { label: "Validation", to: "/docs/forms/validation" },
            { label: "Html Editor", to: "/docs/forms/html-editor" },
        ],
    },
    {
        title: "Navigation",
        icon: "navigation",
        color: "success",
        glow: "lg-success",
        items: [
            { label: "Navbar", to: "/docs/components/navbar" },
            { label: "Navs & tabs", to: "/docs/components/nav" },
            { label: "Breadcrumb", to: "/docs/components/breadcrumb" },
            { label: "Pagination", to: "/docs/components/pagination" },
        ],
    },
    {
        title: "Feedback",
        icon: "feedback",
        color: "danger",
        items: [
            { label: "Alert", to: "/docs/components/alert" },
            { label: "Toast", to: "/docs/components/toast" },
            { label: "Spinner", to: "/docs/components/spinner" },
            { label: "Progress", to: "/docs/components/progress" },
            { label: "Tooltip", to: "/docs/components/tooltip" },
            { label: "Popover", to: "/docs/components/popover" },
        ],
    },
    {
        title: "Data Display",
        icon: "data",
        color: "pink",
        glow: "lg-pink",
        items: [
            { label: "Card", to: "/docs/components/card" },
            { label: "Table", to: "/docs/content/table" },
            { label: "Data table", to: "/docs/content/data-table" },
            { label: "List group", to: "/docs/components/listgroup" },
            { label: "Typography", to: "/docs/content/typography" },
            { label: "Icons", to: "/docs/content/icons" },
            { label: "Image & figures", to: "/docs/content/image" },
        ],
    },
    {
        title: "Components",
        icon: "component",
        color: "violet",
        items: [
            { label: "Button", to: "/docs/components/button" },
            { label: "Button group", to: "/docs/components/buttongroup" },
            { label: "Badge", to: "/docs/components/badge" },
            { label: "Modal", to: "/docs/components/modal" },
            { label: "Dropdown", to: "/docs/components/dropdown" },
            { label: "Accordion", to: "/docs/components/accordion" },
            { label: "Offcanvas", to: "/docs/components/offcanvas" },
        ],
    },
];
